module.exports = __webpack_public_path__ + "icoRepCon.png";